define(["./userPreferencesModule"], function (userPreferencesModule) {
    "use strict";

    return userPreferencesModule.service("planningUserPreferencesService", ["$localStorage", "planningUserPreferencesProperties",
        function ($localStorage, planningUserPreferencesProperties) {

            var ANALYSIS_VIEW_STORAGE_KEY = "planningAnalysisView";
            var ANALYSIS_TYPE_VIEW_STORAGE_KEY = "planningAnalysisTypeView";
            var SELECTION_VIEW_STORAGE_KEY = "planningSelectionView";
            var DEFAULT_VIEW = {"panel": "list-view", "viewType": ["order", "trip"]};
            var DEFAULT_TYPE_VIEW =
                {
                    map: {
                        "key": "analysis-map-basket",
                        "type": {"keyBundle": "br.com.neolog.service.presentationtree.viewType.delivery.unit"}
                    }, analysis: {
                        "key": "basket",
                        "type": {"keyBundle": "br.com.neolog.service.presentationtree.viewType.delivery.unit"}
                    }
                };

            $localStorage[ANALYSIS_TYPE_VIEW_STORAGE_KEY] = {};

            return {
                saveAnalysisViewPreferences: saveAnalysisViewPreferences,
                getAnalysisViewPreferences: getAnalysisViewPreferences,
                saveAnalysisViewTypePreferences: saveAnalysisViewTypePreferences,
                getAnalysisViewTypePreferences: getAnalysisViewTypePreferences,
                saveSelectionViewPreferences: saveSelectionViewPreferences,
                getSelectionViewPreferences: getSelectionViewPreferences
            };

            function saveAnalysisViewPreferences(preferences) {
                if (planningUserPreferencesProperties.isStorePreferencesActive()) {
                    $localStorage[ANALYSIS_VIEW_STORAGE_KEY] = preferences;
                }
            }

            function getAnalysisViewPreferences() {
                if (planningUserPreferencesProperties.isStorePreferencesActive()) {
                    return $localStorage[ANALYSIS_VIEW_STORAGE_KEY] || DEFAULT_VIEW;
                }
                return DEFAULT_VIEW;
            }

            function saveAnalysisViewTypePreferences(preferences, type) {
                if (planningUserPreferencesProperties.isStorePreferencesActive()) {
                    $localStorage[ANALYSIS_TYPE_VIEW_STORAGE_KEY][type] = preferences;
                }
            }

            function getAnalysisViewTypePreferences(type) {
                if (planningUserPreferencesProperties.isStorePreferencesActive()) {
                    return $localStorage[ANALYSIS_TYPE_VIEW_STORAGE_KEY][type] || DEFAULT_TYPE_VIEW[type];
                }
                return DEFAULT_TYPE_VIEW[type];
            }

            function saveSelectionViewPreferences(preferences) {
                if (planningUserPreferencesProperties.isStorePreferencesActive()) {
                    $localStorage[SELECTION_VIEW_STORAGE_KEY] = preferences;
                }
            }

            function getSelectionViewPreferences() {
                if (planningUserPreferencesProperties.isStorePreferencesActive()) {
                    return $localStorage[SELECTION_VIEW_STORAGE_KEY] || DEFAULT_VIEW;
                }
                return DEFAULT_VIEW;
            }
        }]);
});
